// Reads a dotted path ('details.beds', 'arv.criteria.propertyType') out of a nested object -- the
// shape a PATCH response body nests a field in, as opposed to the flat dotted-string key the request
// body and UPDATABLE_PROPERTY_PATHS (reilm-be validation.js) both use for the same field.
export function getIn(obj, path) {
  return path.split('.').reduce((acc, key) => (acc == null ? undefined : acc[key]), obj)
}
